/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_See_PrivacyInputs */

const en_legal_see_privacy = /** @type {(inputs: Legal_See_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const id_legal_see_privacy = /** @type {(inputs: Legal_See_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Privasi`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Legal_See_PrivacyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const legal_see_privacy = /** @type {((inputs?: Legal_See_PrivacyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_See_PrivacyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_legal_see_privacy(inputs)
	return en_legal_see_privacy(inputs)
});